<sk-modal-content dataTest="file-delete-confirm"
                  confirmByKeypress
                  (confirmed)="removeFile()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div *irisIfLoaded="!loading(); loaderType 'fill'">
      {{removeText}}
      @for (linkedFile of linkedFiles(); track linkedFile.id) {
        <iris-dms-file-link-card [linkedFileId]="linkedFile.id" [hideActions]="true"></iris-dms-file-link-card>
      }
      @for (linkedForm of file.forms; track linkedForm.templateId + linkedForm.documentId) {
        <iris-dms-forms-link-card [templateId]="linkedForm.templateId" [documentId]="linkedForm.documentId"></iris-dms-forms-link-card>
      }
    </div>
  </ng-container>
  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Ok' | translate"
      *irisIfLoaded="!loading(); loaderType 'inline'"
      (click)="removeFile()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
